import UDModule from "module/UDModule";
import AZZKUModule from "module/AZZKUModule";
import AZZKUTopModule from "module/AZZKUTopModule";
import getModuleName from "utils/getModuleName";
import "./index.css";

export default function App() {
   
   const module = getModuleName();

   if ( module === "AZZKU" ) return <AZZKUModule/>;
   if ( module === "AZZKU_TOP" ) return <AZZKUTopModule/>;
   if ( module === "UD" ) return <UDModule/>;

   return null;
}